import React from 'react';

const HHTProcess = () => {
  const processSteps = [
    {
      id: 1,
      title: "Briefing con el cliente",
      description: "Entendemos tus necesidades específicas y cultura organizacional",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2" />
        </svg>
      )
    },
    {
      id: 2,
      title: "Reclutamiento activo",
      description: "Búsqueda estratégica en nuestras redes y bases de talento",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      )
    },
    {
      id: 3,
      title: "Evaluación de candidatos",
      description: "Pruebas psicométricas, técnicas y análisis de competencias",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
        </svg>
      )
    },
    {
      id: 4,
      title: "Entrevistas",
      description: "Sesiones profundas para validar habilidades blandas y técnicas",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
        </svg>
      )
    },
    {
      id: 5,
      title: "Presentación del shortlist",
      description: "Entrega de 3-5 candidatos perfectamente alineados a tu vacante",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      )
    },
    {
      id: 6,
      title: "Contratación y seguimiento",
      description: "Apoyo en la incorporación y monitoreo post-contratación",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      )
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-purple-900">Nuestro Proceso de Selección</h2>
          <p className="text-gray-600 mt-4">Metodología probada para garantizar los mejores resultados</p>
        </div>

        {/* Versión móvil: Vertical */}
        <div className="md:hidden">
          <div className="space-y-8">
            {processSteps.map((step) => (
              <div key={step.id} className="flex items-start">
                <div className="bg-purple-100 p-3 rounded-full mr-4 flex-shrink-0">
                  <div className="text-purple-900">
                    {step.icon}
                  </div>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-purple-900 mb-1">{step.title}</h3>
                  <p className="text-gray-600">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Versión desktop: Horizontal */}
        <div className="hidden md:block">
          <div className="relative">
            {/* Línea horizontal */}
            <div className="absolute left-0 right-0 top-1/2 h-1 bg-purple-200 transform -translate-y-1/2"></div>

            <div className="relative flex justify-between">
              {processSteps.map((step) => (
                <div key={step.id} className="flex flex-col items-center w-1/6">
                  <div className="bg-purple-100 p-3 rounded-full mb-4 z-10">
                    <div className="text-purple-900">
                      {step.icon}
                    </div>
                  </div>
                  <div className="text-center px-2">
                    <h3 className="text-lg font-semibold text-purple-900 mb-1">{step.title}</h3>
                    <p className="text-sm text-gray-600">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16 text-center">
          <a href='https://wa.me/5215625464923?text=Hola%2C%20me%20interesa%20contactar%20a%20Hiring%20Human%20Talent.
' target='_blank'>
            <button className="bg-purple-900 hover:bg-purple-800 text-white px-8 py-3 rounded-lg font-medium transition-colors">
              Conocer más detalles
            </button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default HHTProcess;